import React from 'react';
import { Collapse } from 'antd';

import Icon from '@ant-design/icons';
import SvgDownChevron from '../assets/icon/DownChevron';
const { Panel } = Collapse;
const questions = [
  {
    label: 'We’re only a small lake, will this work for us?',
    children: (
      <p>
        100%! Our system has well over 100 venues using the Fishery Manager;
        from the largest UK Day Ticket venues, to small family focused pleasure
        lakes. Our system has been developed to accommodate venues of all sizes
        and we’d be more than happy to show you how your venue can best take
        advantages of the tools we’ve developed.
      </p>
    ),
  },
  {
    label: 'Will we lose control of our bookings?',
    children: (
      <>
        <p>
          Not at all! Once live and taking bookings, you will have full access
          to manage, control and delete bookings. You can even add our
          incredible booking widget to your website so that anglers can book
          directly from your own site. Our team will work to assist in getting
          you more bookings, but full control over your anglers’ sessions lies
          with you.
        </p>
      </>
    ),
  },
  {
    label: 'We currently operate with cash in the business? Can this continue?',
    children: (
      <>
        <p>
          Of course! Although swimbooker is a digital platform, we are all too
          aware of the need for fishery businesses around the UK to maintain
          physical cash flow.
        </p>
        <p>
          Some lakes on our platform will set a deposit value to pay up front
          followed by a payment upon arrival at the fishery. This is perfect as
          it avoids cancellations from the angler (having already paid a
          deposit) but it also means the fishery will maintain cash in the
          business.
        </p>
      </>
    ),
  },
  {
    label:
      'I’m interested but it feels like a headache to transfer everything online! How long does it take?',
    children: (
      <>
        <p>
          We hear you! It can be daunting to either switch from your current
          provider or move online for the first time. After onboarding well over
          100 venues over 2 years, we can safely say that it’s an easy, seamless
          process and we take care of everything for you.
        </p>

        <p>
          In our extensive experience, we’ve been able to accommodate even the
          most complex cases in no more than 7 days, with the average time from
          signing up to going live being 3-4 days. Our expert account managers
          will be in touch and ensure a smooth transition, taking into account
          your specific needs.
        </p>
      </>
    ),
  },
  {
    label: 'swimbooker? I don’t want anglers to have to book a swim!',
    children: (
      <p>
        We fully appreciate that not all fisheries require anglers to pre-book a
        particular swim/peg. That is why we’ve built our platform to accommodate
        every possible booking requirement. Whether you sell Watercraft Tickets,
        Swims, Lake Exclusives, Accommodation or a mixture of all, our platform
        can easily be set up as you need.
      </p>
    ),
  },
  {
    label:
      'I want to be part of the swimbooker platform but don’t think it will suite the way I run my fishery!',
    children: (
      <>
        <p>
          We’ve heard this many times before! With fishery owners across the UK
          running their lakes in vastly different ways, we’ve had to work
          closely with our clients to ensure platform suitability for everyone.
        </p>
        <p>
          We are confident that we can accommodate your needs, whether you have
          unique pricing models, variable booking restrictions or any other
          unique requirement.
        </p>
        <p>
          After discussion with our expert team, if it becomes apparent we will
          need to customise your account, our in-house team of developers will
          do the hard work and code your developments until you are happy and
          ready to go live!
        </p>
      </>
    ),
  },
  {
    label:
      'There are multiple systems on the market, why should I use swimbooker?',
    children: (
      <>
        <p>
          We believe that the best technology platform available in every
          industry are FREE to the end user. This encourages growth and promotes
          user take up which is required to create an ecosystem that benefits
          all stakeholders.
        </p>
        <p>
          Our ethos since we started was to maintain a FREE to use platform for
          anglers and we will continue to do so. The numbers don’t lie; with
          over 50K+ anglers accounts and £7.9M in bookings processed it’s clear
          anglers prefer using swimbooker to book their next session.
        </p>
        <p>
          Finally, we have a unique focus on building the best technology
          product in the market. Angling isn’t flooded with high quality, well
          built tech products. We are the only company with a strong focus on
          changing this.
        </p>
      </>
    ),
  },
  {
    label: 'Will I be able to see when anglers are arriving and leaving?',
    children: (
      <>
        <p>
          Yes, in addition to email and dashboard notifications for new
          bookings, you can easily view who is arriving and leaving each of the
          lakes on your complex. Our ‘Who’s at My Lake’ section will inform you
          on a daily basis who is meant to be at the lake making it easy for
          owners or bailiffs to manage the venue.
        </p>
        <p>
          In addition, our easy to use calendar traffic light system indicates
          daily availability in an easy to digest fashion.
        </p>
      </>
    ),
  },
  {
    label: 'Can I set restrictions on how far in advance anglers can book?',
    children: (
      <>
        <p>
          Yes, all bookings rules, including pricing, availability and
          promotions can be defined by yourself. This means once set up, you
          will never receive bookings that you don’t want. You can also define
          date or day specific restrictions (i.e minimum 48hr bookings on
          weekends, etc.)
        </p>
      </>
    ),
  },
  {
    label: 'Can I capture additional details when anglers book?',
    children: (
      <>
        <p>
          Of course! You can choose to request things like address or car
          registration to provide you with more information when a booking is
          made. This is saved on the booking file and can be referenced at any
          point in case it’s required. For lake exclusives, we also request the
          number of expected anglers in the party.
        </p>
      </>
    ),
  },
  {
    label: 'How does it work in relation to refunds or cancellations?',
    children: (
      <>
        <p>
          When booking with swimbooker, anglers are clearly informed that
          refunds and cancellations are down to the discretion of the fishery.
          When our support team receives a request of this nature, we
          immediately inform the fishery directly and ask them how they would
          like to proceed.
        </p>
        <p>
          Anglers are unable to directly cancel their booking or receive a
          refund online through their swimbooker account.
        </p>
      </>
    ),
  },
];

export default function FAQs() {
  return (
    <div className='faq-collapse-container'>
      <Collapse
        className='faq-collapse rounded-none sb-blue-bg-800 grey-200'
        accordion
        items={questions}
        defaultActiveKey={0}
        expandIconPosition='end'
        bordered={false}
        expandIcon={() => <Icon component={SvgDownChevron} />}
      >
        {questions.map((data, index) => (
          <Panel header={data.label} key={index} className='faq-collapse'>
            {data?.children}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
}
